/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 立即购票锁定座位
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  lockSeatNow: order.LockSeatNow,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: string;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/order/lock-seat-now`,
    data: lockSeatNow,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
